<template>
  <div>
    <div>
      <!-- 버튼 리스트 -->
      <v-list>
        <template>
          <draggable :list="buttons">
            <v-list-tile
              class="cursor"
              v-for="(item, index) in buttons" :key="index"
              @click="buttonAction(item)"
              >
              <v-list-tile-content>
                <v-list-tile-title class="fs-16" v-html="item.name" style="text-align: center"></v-list-tile-title>
              </v-list-tile-content>
              <!-- <v-list-tile-action v-if="item.buttonType === 'LINK_BUTTON'" style="min-width: 40px">
              </v-list-tile-action>
              <v-list-tile-action v-else-if="item.buttonType === 'TEL_BUTTON'" style="min-width: 40px">
              </v-list-tile-action>
              <v-list-tile-action v-else-if="item.buttonType === 'URL_BUTTON'" style="min-width: 40px">
              </v-list-tile-action> -->
            </v-list-tile>
          </draggable>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'templateButton',
  components: {
    draggable
  },
  data () {
    return {
      buttons: []
    }
  },
  props: {
    order: {
      type: Number
    }
  },
  computed: {
    ...mapGetters([
      'currentBrandId',
      'marketingLineTemplateContent'
    ])
  },
  watch: {
    marketingTemplateContent () {
      this.initButton()
    }
  },
  destroyed () {
  },
  mounted () {
    this.initButton()
  },
  methods: {
    ...mapMutations([
    ]),
    buttonAction (item) {
      if (item.buttonType === 'URL_BUTTON') {
        window.open(item.url, '_blank')
      } else if (item.buttonType === 'TEL_BUTTON') {
        window.open('tel:' + item.callNumber, '_blank')
      } else {
        return false
      }
    },
    initButton () {
      if (this.marketingLineTemplateContent) {
        let textContent = this.marketingLineTemplateContent[this.order].content
        this.buttons = textContent.button
      } else {
        this.buttons = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/line/components/templateFragments/templateButton.vue